export class IAddress {
   _id: string;
   street: string;
   city: string;
   zipCode: string;
   town: string;
   state: string;
   country: string;
}